const Contact = () => {
    return <div className="contaier">
        <div className="row">
            <h1 className="text-center p-5 display-1">Contact</h1>
            <hr></hr>
            <p className="text-center p-5 display-6"><b>email:</b> deza41@hotmail.com</p>
            <p className="text-center p-5 display-6"><b>Personal Website: </b>
            <a href="https://www.tyronedeza.com/">Click Here</a> </p>
        </div>
    </div>
}

export default Contact;